import axios from 'axios'

// Get all producers
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/producer`)
  return data
}

// Get all producers from business
const getByBusiness = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/producer/business`)
  return data
}

// Create producer
const create = async (name, email) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/producer`, {
    name,
    email
  })
  return data
}

// Update producer
const update = async (idUser, name, email) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/producer/${idUser}`, {
    name,
    email
  })
  return data
}

export {
  getAll,
  getByBusiness,
  create,
  update
}
